const CONTENT_TYPE_PDF = 'application/json';
const PDF = '.pdf';
const BLOB_CONTENT_TYPE_PDF = `data:${CONTENT_TYPE_PDF};base64,`;

export default {
    CONTENT_TYPE_PDF,
    PDF,
    BLOB_CONTENT_TYPE_PDF,
};
